import { MenuItem, MenuItemProps } from '@mui/material'
import { FC } from 'react'

const MenuItemWrapper: FC<MenuItemProps> = ({ ...props }) => (
  <MenuItem {...props} />
)

export default MenuItemWrapper
